import trackerHelper from "@coworker/app/src/helpers/tracker";
import FixaPill from "../../../wrappers/FixaPill/FixaPill";
import PillCheckboxCss from "./PillCheckbox.module.css";
import { CheckboxFilter, FilterValue } from "../../types/filter";
import { TrackingProps } from "../../types/component";

interface PillCheckboxProps {
  filter: CheckboxFilter;
  filterValues: FilterValue[];
  setFilterValues: (filterValues: FilterValue[]) => void;
  tracking: TrackingProps;
}

export const PillCheckbox = ({
  filter,
  filterValues,
  setFilterValues,
  tracking,
}: PillCheckboxProps) => {
  const checked = filterValues.some((value) => value.filterId === filter.id);

  const handleCheckboxClick = () => {
    if (!checked) {
      trackerHelper.filter.trackFilterRowClicked(
        tracking.feature,
        tracking.mode,
        filter.id
      );
    }

    const updatedFilters = filterValues.filter(
      (value) => value.filterId !== filter.id
    );

    setFilterValues(
      checked
        ? updatedFilters
        : [
            ...updatedFilters,
            {
              filterId: filter.id,
              value: true,
              dependsOnFilterId: filter.dependsOnFilterId,
            },
          ]
    );
  };

  return (
    <FixaPill
      id={filter.id}
      size="small"
      label={
        <div className={PillCheckboxCss["pill-wrapper"]}>
          {filter.title}
          <input
            className={PillCheckboxCss["checkbox"]}
            type="checkbox"
            checked={checked}
            readOnly
          />
        </div>
      }
      onClick={handleCheckboxClick}
    />
  );
};
